module.exports = __webpack_public_path__ + "static/media/default.f232199c.jpg";